<!-- 承运商档案>新增>网点维护 -->
<template>
  <div id="network">
    <div class="btns">
      <!-- <el-button
        class="btnItems"
        v-if="hasPermiss('aaaaa')"
        @click="exportBtn()"
      >
        导出
      </el-button>
      <el-button
        class="btnItems"
        v-if="hasPermiss('aaaaa')"
        @click="pointTemp()"
      >
        下载导入模板
      </el-button>
      <el-button class="btnItems" v-if="hasPermiss('aaaaa')" @click="point()">
        导入
      </el-button>-->
      <el-button class="btnItems" v-if="hasPermiss('admin:carrier:delCarrierDept')" @click="delBtns()">删除</el-button>
      <el-button class="btnItems" v-if="hasPermiss('admin:carrier:udpateCarrierDept')" @click="modify()">编辑</el-button>
      <el-button class="btnItems" v-if="hasPermiss('admin:carrier:addCarrierDept')" @click="add()">添加</el-button>
    </div>
    <div class="tablebox">
      <div class="glo_Table">
        <el-table
          :height="tableHeight"
          header-align="center"
          ref="mytable"
          @row-click="rowclick"
          :data="tableData"
          border
          stripe
          :highlight-current-row="true"
          @selection-change="handleSelectionChange"
        >
          <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
          <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
          <el-table-column v-for="(item, index) in tableHead" :key="index" :label="item.name" :prop="item.field" align="center" :show-overflow-tooltip="true" :min-width="item.width"></el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="diaCancelBtn" @diaConfirmBtn="diaConfirmBtn">
      <div class="addForm">
        <el-form :model="formdata" v-if="isShowDialog" ref="addForm" :rules="rules" label-width="100px" class="dia_form">
          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="承运商:" prop="carrierId">
                <el-select v-model="formdata.carrierId" placeholder="自动获取" disabled>
                  <el-option :label="info.carrierName" :value="info.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="网点名称:" prop="deptName">
                <el-input v-model="formdata.deptName" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-form-item label="所在省市区:" prop="provinceName">
              <el-col :span="8">
                <el-select v-model="formdata.provinceName" @change="changeProvince" placeholder="请选择省" clearable filterable>
                  <el-option v-for="(item, index) in provinceArr" :key="index" :label="item.districtName" :value="item.districtName" />
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-select v-model="formdata.cityName" @change="changeCity" placeholder="请选择市" clearable filterable>
                  <el-option v-for="(item, index) in cityArr" :key="index" :label="item.districtName" :value="item.districtName" />
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-select v-model="formdata.areaName" placeholder="请选择区" clearable filterable>
                  <el-option v-for="(item, index) in districtArr" :key="index" :label="item.districtName" :value="item.districtName" />
                </el-select>
              </el-col>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="详细地址:" prop="address">
                <el-input v-model="formdata.address" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="联系电话:" prop="phone">
                <el-input v-model="formdata.phone" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人:" prop="contacts">
                <el-input v-model="formdata.contacts" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="备注:" prop="remark">
                <el-input type="textarea" rows="2" v-model="formdata.remark" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="默认网点:" prop="isDefault">
                <el-checkbox v-model="formdata.isDefault">默认</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </my-dialog>
  </div>
</template>
  <script >
import myDialog from "@/components/Dialog.vue";
import paging from "@/components/pagings.vue"; //分页组件
export default {
  components: { myDialog, paging },
  props: {
    common: {
      type: Object,
    },
  },
  data() {
    return {
      info: {
        carrierName: this.common.carrierName,
        id: this.common.carrierId,
      },
      provinceArr: null,
      cityArr: null,
      districtArr: null,
      pageStart: 1,
      pageCount: 0,
      pageTotal: this.$COMMON.pageTotals,
      tableHeight: "75vh", //  表格高度
      tableData: [],
      tableHead: [
        {
          name: "默认网点",
          field: "isDefaultShow",
          width: "120",
        },
        {
          name: "网点名称",
          field: "deptName",
          width: "120",
        },
        {
          name: "所在省份",
          field: "provinceName",
          width: "160",
        },
        {
          name: "所在城市",
          field: "cityName",
          width: "160",
        },
        {
          name: "所在区县",
          field: "areaName",
          width: "120",
        },
        {
          name: "详细地址",
          field: "address",
          width: "120",
        },
        {
          name: "联系人",
          field: "contacts",
          width: "120",
        },
        {
          name: "联系电话",
          field: "phone",
          width: "120",
        },
        {
          name: "备注",
          field: "remark",
          width: "120",
        },
      ],
      selectTableData: [],
      diaWidth: "50%",
      dialogTitle: null,
      isShowDialog: false,
      defaultFormData: {
        carrierId: null,
        address: null,
        areaName: null,
        cityName: null,
        contacts: null,
        deptName: null,
        phone: null,
        provinceName: null,
        remark: null,
        isDefault: false,
      },
      formdata: { isDefault: false },
      rules: {
        deptName: [{ required: true, message: "请输入", trigger: "blur" }],
        address: [{ required: true, message: "请输入", trigger: "blur" }],
        phone: [{ required: true, message: "请输入", trigger: "blur" }],
        contacts: [{ required: true, message: "请输入", trigger: "blur" }],
        provinceName: [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.GetData();
    this.getParentName("中华人民共和国"); //默认查到各省
  },
  watch: {
    common: {
      handler(nv, ov) {
        console.log(nv);
        this.info.carrierName = nv.carrierName;
        this.info.id = nv.carrierId;
        this.GetData();
      },
      deep: true,
    },
  },
  methods: {
    // 选择省(收货地址)
    changeProvince(e) {
      this.formdata.cityName = "";
      this.formdata.areaName = "";
      this.cityArr = [];
      this.districtArr = [];
      if (e) {
        this.getCityName(e);
      }
    },
    // 选择市(收货)
    changeCity(e) {
      this.formdata.areaName = "";
      this.districtArr = [];
      if (e) {
        this.getAreaName(e);
      }
    },
    // 默认查省级
    getParentName(e) {
      let p = {
        pageStart: 1,
        pageTotal: 100,
        parentName: e,
      };
      this.$API.wtl_getDistrictList(p).then((res) => {
        this.provinceArr = res.data.result.data || [];
      });
    },
    // 获取市
    getCityName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.cityArr = res.data.result.data || [];
        });
    },
    // 获取区
    getAreaName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.districtArr = res.data.result.data || [];
        });
    },
    // 获取网点列表
    GetData() {
      let queryData = new Object();
      queryData.pageStart = this.pageStart;
      queryData.pageTotal = this.pageTotal;
      queryData.carrierId = this.info.id;
      this.$API.CarrierDeptList(queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          // this.$nextTick(() => {
          //   this.fetTableHeight();
          // });
        } else {
          this.$message.error(`${res.data.message}---网点列表`);
        }
      });
    },
    // 删除
    delBtns(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              carrierDeptIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.carrierDeptIds.push(val.carrierDeptId);
            });
            this.$API.delCarrierDept(delReq).then((res) => {
              if (res.data.status === "success") {
                try {
                  let num = 0;
                  let arr = this.tableConfig.tableData;
                  if (delReq.carrierDeptIds.length > 2) {
                    delReq.carrierDeptIds.map(function (v, i) {
                      num = arr.findIndex(
                        (element) => element.carrierDeptId == v
                      );
                      arr.splice(num, 1);
                    });
                  } else {
                    num = arr.findIndex(
                      (element) =>
                        element.carrierDeptId == delReq.carrierDeptIds[0]
                    );
                    arr.splice(num, 1);
                  }
                } catch {
                  this.GetData();
                }
                this.$message.success("已删除");
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 修改
    modify(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        let getdata = this.selectTableData[0];
        if (getdata.provinceName) {
          this.changeProvince(getdata.provinceName);
        }
        if (getdata.cityName) {
          this.changeCity(getdata.cityName);
        }
        this.formdata = getdata;
        this.formdata.isDefault = getdata.isDefault == 1 ? true : false;
        this.dialogTitle = "修改网点维护";
        this.isShowDialog = true;
      }
    },
    // 新增
    add() {
      this.formdata.carrierId = this.info.id;
      this.dialogTitle = "新增网点维护";
      this.isShowDialog = true;
    },
    exportBtn() {
      this.$message.info("导出按钮");
    },
    pointTemp() {
      this.$message.info("导入模版按钮");
    },
    point() {
      this.$message.info("导入按钮");
    },
    handleSizeChange(val) {
      this.pageTotal = val;
      this.GetData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.GetData();
    },

    // 表格
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          let param = {};
          for (let key in this.defaultFormData) {
            if (this.formdata[key] || this.formdata[key] == 0) {
              eval("param." + key + "='" + this.formdata[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          if (this.formdata.carrierDeptId)
            param.carrierDeptId = this.formdata.carrierDeptId;
          let Arr = ["provinceName", "cityName"];
          for (let i in Arr) {
            let p = Arr[i];
            if (param[p] !== null) {
              param[p] = param[p].replace(/[0-9]+/g, "");
            }
          }
          param.isDefault = this.formdata.isDefault ? 1 : 0;
          if (param.carrierDeptId && param.carrierDeptId !== null) {
            // 修改接口
            this.$API.udpateCarrierDept(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          } else {
            // 新增接口
            this.$API.addCarrierDept(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          }
          this.isShowDialog = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.formdata = {};
      this.isShowDialog = false;
    },

    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },
  },
};
</script>
  <style scoped lang="less">
#network {
  margin: 40px 40px;
  .btns {
    flex: 1;
    .btnItems {
      border: 1px solid #606266;
      background-color: #fff;
      color: #333;
      padding: 5px 20px;
      margin-left: 10px;
      margin-bottom: 8px;
    }

    .el-button:hover {
      border: 1px solid #ef7c0a;
      color: #ef7c0a;
    }
  }
  .addForm {
    margin: 10px 40px;
  }
  .dia_form {
    .el-form-item {
      margin-bottom: 0px;
      min-width: 260px;
    }
  }
}
</style>
  